import { ORGANIC_REFERRER_PATTERNS_OBJ } from '@packages/shared/core/common/constants';
import { OrganicChannel } from '@packages/shared/core/common/entities';

export const getOrganicChannel = (referrer: string) => {
  const matchedEntry = Object.entries(ORGANIC_REFERRER_PATTERNS_OBJ).find(([, pattern]) => pattern.test(referrer));
  return matchedEntry ? (matchedEntry[0] as OrganicChannel) : null;
};
